export default {
    methods: {
        formulateCustomerNames(customer_object){
            return this.formulateNames(customer_object?.customer_first_name, customer_object?.customer_last_name);
        },
        formulateNames(first_name, last_name){
            return (first_name?(first_name+" "):"")+(first_name==last_name?"":last_name);
        },
    }
}